export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    CAD = 'CAD',
    AUD = 'AUD',
    CHF = 'CHF',
    GBP = 'GBP',
    JPY = 'JPY',
    NZD = 'NZD',
}
